import React from 'react';
import ReportsPage from './pages/ReportsPage';
export function App() {
  return <ReportsPage data-id="element-0" />;
}